import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../../../hooks/useImagesLoaded';
import { COLOR_BLACK, COLOR_WHITE, COLOR_GIGGITY } from '../../../colors';
import { ROBOTO_SLAB } from '../../../fonts';
import { Arrow, FairHousingLogo } from '../../icons';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        height: '100%',
        fontFamily: ['"Roboto Slab"', 'serif'],
        position: 'relative',
        backgroundColor: COLOR_WHITE,
    },
    contentWrap: {
        textAlign: 'left',
        minWidth: '100%',
        height: '100%',
        boxSizing: 'border-box',
        padding: '50px',
        fontSize: '32px',
        lineHeight: '48px',
        backgroundImage: 'url("./images/Notable/bg-bluehouse.svg")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top 130px right 50px',
        backgroundSize: 'auto',
        position: 'relative',
    },
    heading: {
        fontSize: '42px',
        lineHeight: '52px',
        fontWeight: 700,
        color: COLOR_BLACK,
        padding: '0 300px 20px 0',
    },
    body: {
        color: COLOR_BLACK,
        paddingRight: '300px',
    },
    readMore: {
        marginTop: 20,
        fontSize: '32px',
        lineHeight: '32px',
        color: COLOR_BLACK,
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    arrow: {
        marginLeft: 20,
    },
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '16%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            width: 400,
            height: 400,
            left: '-50%',
        },
    },
    disclaimerWrap: {
        position: 'absolute',
        bottom: 10,
        left: 50,
        color: COLOR_GIGGITY,
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: ['Arial', 'sans-serif'],
    },
    disclaimer: {
        marginTop: 3,
    },
    fairHousing: {
        position: 'absolute',
        bottom: 10,
        right: 50,
    },
}));


export default function BlueHouse({
    templateContent = {},
    onImagesLoaded = null,
}) {
    const classes = useStyles();
    const {
        title,
        body,
        watermark = false,
    } = templateContent || {};
    const bgImage = './images/Notable/bg-bluehouse.svg';
    const loadedBgs = useImagesLoaded([bgImage]);

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
        return ()=> {
            window.isLoaded = false;
        };
    }, [loadedBgs, onImagesLoaded]);


    return (
        <>
            <link rel="stylesheet" href={ROBOTO_SLAB} />
            <div className={classes.container}>
                <div className={classes.contentWrap}>
                    <div className={classes.content}>
                        <div className={classes.heading}>
                            {title}
                        </div>

                        {body && (<div className={classes.body} dangerouslySetInnerHTML={{__html: body}}></div>)}

                        <div className={classes.readMore}>
                            <div>
                                Read more
                            </div>
                            <div className={classes.arrow}>
                                <Arrow size={42} />
                            </div>
                        </div>
                    </div>
                </div>
                {watermark && (<div className={classes.watermark}>
                    <img src="./images/watermark-stamp.svg" alt="Watermark" />
                </div>)}


                {/* Disclaimer */}
                <div className={classes.disclaimerWrap}>
                    <img src="./images/lr-logo-disclaimer-grey.svg" height={20} alt="LR Logo" />
                    <div className={classes.disclaimer}>
                        &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved
                    </div>
                </div>

                <div className={classes.fairHousing}><FairHousingLogo height={24} /></div>
            </div>
        </>
    );
}
